import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import { createWrapper } from 'next-redux-wrapper';
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';
import { composeWithDevTools } from '@redux-devtools/extension';

import rootReducer from '../store/reducers/rootReducer';
import wsMiddleware from '../config/middleware/websocketMiddleware';
import tracker from '../helpers/tracker';

let middleware = [];
if (
  (process.env.NODE_ENV !== 'production' ||
    process.env.REACT_APP_CUSTOM_NODE_ENV === 'staging') &&
  process.env.NEXT_REDUX_LOGGER
) {
  // eslint-disable-next-line global-require
  const logger = require('redux-logger').createLogger();
  middleware = [logger];
}

const enhancer = composeWithDevTools(
  applyMiddleware(thunk),
  applyMiddleware(tracker.middleware),
  applyMiddleware(wsMiddleware),
  applyMiddleware(...middleware)
);

const createNoopStorage = () => {
  return {
    getItem() {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem() {
      return Promise.resolve();
    },
  };
};

const storage =
  typeof window !== 'undefined'
    ? createWebStorage('local')
    : createNoopStorage();

const persistConfig = {
  key: 'root',
  storage,
  version: 4,
  whitelist: ['authState', 'uiState', 'paymentsState', 'creditLineState'],
  timeout: null,
  migrate: state => {
    return Promise.resolve(state);
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, enhancer);
const persistor = persistStore(store);
const wrapper = createWrapper(() => store);

export { store, persistor, wrapper };
